import { ChangeEvent } from 'react';
import { FormInput, DatePickerComponent } from '../../../component/input/InputStyle';
import GridComponent from '../../../component/grid/GridComponent.component';
import FormLabel from '../../../component/input/FormLabel.component';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { useState } from 'react';
import CorporateCommunicated from '../interfaces/CorporateCommunicated';
import { FormInterface } from '../../../core/interfaces/form/Form';
import useDebounce from '../../../hooks/useDebounce';

export default function FormComponent({ handleSubmitForm, initialValues }: FormInterface<CorporateCommunicated>) {

    const [values, setValues] = useState<CorporateCommunicated>(initialValues);
    const debounce = useDebounce(handleSubmitForm, 400);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setValues({ ...values, [name]: value });
        let valueAux: CorporateCommunicated = { ...values, [name]: value }
        debounce({ ...valueAux })
    }

    const handleChangeDate = (date: Date | string, name: string) => {
        setValues({ ...values, [name]: date });
        let valueAux: CorporateCommunicated = { ...values, [name]: date }
        debounce({ ...valueAux });
    }

    return (
        <form>
            <GridComponent justify="flex-start" alignItems="flex-start" spacing={2} >
                <FormLabel title="Assunto" xs={12} sm={4} >
                    <FormInput
                        name="Assunto"
                        value={values.Assunto || ''}
                        onChange={handleChange}
                        required
                    />
                </FormLabel>
                <FormLabel title="data de início" xs={6} sm={4} >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePickerComponent
                            value={values.DataInicio || null}
                            maxDateMessage="data não pode ser maior que Data de Fim"
                            maxDate={values.DataFim || null}
                            onChange={(date: Date | string) => handleChangeDate(date, 'DataInicio')}
                            renderInput={(props: any) => <FormInput {...props} />}
                        />
                    </LocalizationProvider>
                </FormLabel>
                <FormLabel title="data de fim" xs={6} sm={4} >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePickerComponent
                            value={values.DataFim || null}
                            minDate={values.DataInicio || null}
                            maxDateMessage="data não pode ser menor que Data de Inicio"
                            onChange={(date: Date | string) => handleChangeDate(date, 'DataFim')}
                            renderInput={(props: any) => <FormInput {...props} />}
                        />
                    </LocalizationProvider>
                </FormLabel>

            </GridComponent>
        </form>
    )
}